import React, { useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
  root: {
    position: 'relative',
    paddingTop: (props) => `calc(1 / ${props.aspectRatio} * 100%)`,
  },
  image: {
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    objectFit: 'cover',
    height: 'auto',
    maxWidth: '100%',
    opacity: (props) => props.fadeIn && (props.loading ? 0 : 1),
    transition: (props) =>
      props.fadeIn &&
      `opacity ${props.animationDuration}ms cubic-bezier(0.4, 0.0, 0.2, 1)`,
  },
});

const LazyImage = (props) => {
  const {
    alt,
    src,
    srcSet,
    sources = [],
    fadeIn = true,
    aspectRatio = 1,
    animationDuration = 500,
  } = props;

  const [loading, setLoading] = useState(true);

  const classes = useStyles({
    aspectRatio,
    animationDuration,
    fadeIn,
    loading,
  });

  return (
    <div className={classes.root}>
      <picture>
        {sources.map(({ type, srcSet }, i) => (
          <source key={i} type={type} srcSet={srcSet} />
        ))}
        <img
          className={classes.image}
          src={src}
          srcSet={srcSet}
          alt={alt}
          onLoad={() => setLoading(false)}
        />
      </picture>
    </div>
  );
};

export default LazyImage;
